// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d255234","453":"464095ea","732":"eca7c249"}[chunkId] + ".chunk.js";
};